import { motion } from "framer-motion";
import LeadForm from "@/components/sections/LeadForm";
import { IMG } from "@/data/content";

export default function FinalCTA() {
  return (
    <section data-testid="final-cta-section" className="relative section-pad overflow-hidden">
      <div className="absolute inset-0 -z-10">
        <img src={IMG.bakeryAmbient} alt="" className="w-full h-full object-cover opacity-15" />
        <div className="absolute inset-0 bg-gradient-to-b from-bg via-bg/95 to-bg" />
      </div>
      <div className="max-w-6xl mx-auto container-px grid lg:grid-cols-12 gap-12 items-start">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="lg:col-span-5"
        >
          <p className="eyebrow mb-4">Hai să discutăm</p>
          <h2 className="h-display text-3xl md:text-5xl text-text">
            Hai să punem produse <br />
            <em className="text-gold not-italic">mai bune în meniul tău.</em>
          </h2>
          <p className="mt-6 text-base md:text-lg text-text-soft leading-relaxed">
            Spune-ne ce tip de afacere ai, iar noi îți recomandăm produsele potrivite pentru ritmul, meniul și clienții tăi.
            Primești o ofertă reală, nu un email automat.
          </p>
          <div className="mt-8 space-y-3 text-sm text-text-soft">
            <div className="flex items-center gap-3">
              <span className="h-1.5 w-1.5 rounded-full bg-gold" />
              Răspuns în maxim 24h în zilele lucrătoare
            </div>
            <div className="flex items-center gap-3">
              <span className="h-1.5 w-1.5 rounded-full bg-gold" />
              Mostre și catalog pentru parteneri serioși
            </div>
            <div className="flex items-center gap-3">
              <span className="h-1.5 w-1.5 rounded-full bg-gold" />
              Recomandări personalizate pentru meniul tău
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
          className="lg:col-span-7"
        >
          <div className="card-soft p-7 md:p-10">
            <LeadForm />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
